export default function kibritAdmin ({ next, store }){
    if(store.getters.getUserRole!="KibritAdmin"){
        return next({
           name: 'dashboard'
        })
    }
   
    return next()
   }